<script setup lang="ts">
// This component can be refactored/simplified by using a yup schema
// with vee-validates validatios, instead of the custom validation logic we have now.
// However, the behaviour now should (almost) work as we want:
// - Only show an error if the user has completed typing (has blurred)
// - Clear error when input is cleared or value is valid
// - Change the placeholder as soon as the input receives focus

const props = defineProps<{ modelValue: string | undefined, label?: string }>()
const emit = defineEmits(['update:modelValue'])

const { t } = useI18n({
  useScope: 'local',
})

const postcode = ref(props.modelValue)

watch(postcode, () => {
  // TODO: only emit when the postcode is valid?
  emit('update:modelValue', postcode.value)

  // Quickfix for clearing error when input is cleared
  if (!postcode.value) {
    postcodeError.value = undefined
  }
})

// postcode UI state
const postcodeError = ref<string | undefined>(undefined)
const postcodeHasFocus = ref(false)
const postcodeWasBlurred = ref(false)
function onPostcodeBlur() {
  postcodeHasFocus.value = false
  postcodeWasBlurred.value = true
  validatePostcode()
}
function validatePostcode() {
  // TODO: validate actual postcode format
  if (
    postcode.value
    && postcode.value.length > 0
    && postcode.value.trim().length != 6
  ) {
    postcodeError.value = t('postcodeError')
  }
  else {
    postcodeError.value = undefined
  }
}
function onPostcodeChange() {
  if (postcodeWasBlurred.value) {
    validatePostcode()
  }
}
</script>

<template>
  <BaseInput
    v-model="postcode"
    :label="label"
    :error="postcodeError"
    shape="rounded"
    icon="lucide:map-pin"
    :placeholder="postcodeHasFocus ? '1234AB' : t('postcode')"
    aria-label="Postcode"
    @focus="postcodeHasFocus = true"
    @blur="onPostcodeBlur"
    @input="onPostcodeChange"
  >
    <template #action>
      <BaseInputClearButton @click="postcode = ''" />
    </template>
  </BaseInput>
</template>

<i18n lang="json">
{
  "en": {
    "postcode": "Postcode",
    "postcodeError": "Enter a valid postcode"
  },
  "nl": {
    "postcode": "Postcode",
    "postcodeError": "Voer een geldige postcode in"
  }
}
</i18n>
